import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EnvironmentService } from "../services/environment.service";
import { BYPASS_BASE_URL } from "../utils/config.constants";

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

    private _environment = inject(EnvironmentService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Se l'URL è già assoluta (http/https)
        if (req.url.startsWith('http')) {
            return next.handle(req);
        }

        // Se è presente il token ed è true
        if (req.context.get(BYPASS_BASE_URL)) {
            return next.handle(req);
        }

        // Aggiungo il baseUrl
        const baseUrl = this._environment.baseApiUrl();
        const apiRequest = req.clone({url: `${baseUrl}/${req.url}`});
        return next.handle(apiRequest);
    }
}
